module.exports = __webpack_public_path__ + "img/construtotas-44647067.jpg";